// extracted by mini-css-extract-plugin
module.exports = {"root":"SpCalendarHeader_root__hs_5r","mx_16":"SpCalendarHeader_mx_16__FJIB_"};